import { render, staticRenderFns } from "./AdminAccount.vue?vue&type=template&id=68e96961&scoped=true"
import script from "./AdminAccount.vue?vue&type=script&lang=js"
export * from "./AdminAccount.vue?vue&type=script&lang=js"
import style0 from "./AdminAccount.vue?vue&type=style&index=0&id=68e96961&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e96961",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68e96961')) {
      api.createRecord('68e96961', component.options)
    } else {
      api.reload('68e96961', component.options)
    }
    module.hot.accept("./AdminAccount.vue?vue&type=template&id=68e96961&scoped=true", function () {
      api.rerender('68e96961', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/master/admin/AdminAccount.vue"
export default component.exports